(function () {
    'use strict';

    /* ═══════════════════════════════════════════════════════════════
     SHARED UTILITIES
    ═══════════════════════════════════════════════════════════════ */
    var isDE = (document.documentElement.lang || '').toLowerCase().indexOf('de') === 0;
    /* ═══════════════════════════════════════════════════════════════
   GLOBAL ATTRIBUTION INJECTION (NO-TOUCH METHOD)
═══════════════════════════════════════════════════════════════ */
    function initAttribution() {
      var storedDataStr = localStorage.getItem('inne_first_touch_attr');
      if (!storedDataStr) return;

      try {
        var attr = JSON.parse(storedDataStr);
        var attrString = '';

        // Build the STRICTLY ENCODED string so Shopify doesn't reject it
        for (var key in attr) {
          if (attr.hasOwnProperty(key) && attr[key]) {
            // %5B = [  |  %5D = ]  |  %3D = =
            attrString += '%26attributes%5B' + encodeURIComponent(key) + '%5D%3D' + encodeURIComponent(attr[key]);
          }
        }

        if (!attrString) return;

        var checkoutStrUnencoded = '%26return_to=/checkout';
        var checkoutStrEncoded = '%26return_to%3D%2Fcheckout';

        function injectIntoUrl(url) {
          if (!url || url === '#') return url;
          // Prevent double injection if the script runs twice
          if (url.indexOf('%26attributes%5Blanding_page') !== -1) return url;

          if (url.indexOf(checkoutStrUnencoded) !== -1) {
            return url.replace(checkoutStrUnencoded, attrString + checkoutStrUnencoded);
          } else if (url.indexOf(checkoutStrEncoded) !== -1) {
            return url.replace(checkoutStrEncoded, attrString + checkoutStrEncoded);
          }
          return url;
        }

        // Mutate V1 Plans
        document.querySelectorAll('.plan-option').forEach(function (plan) {
          if (plan.dataset.productIdYearly) plan.dataset.productIdYearly = injectIntoUrl(plan.dataset.productIdYearly);
          if (plan.dataset.productIdMonthly)
            plan.dataset.productIdMonthly = injectIntoUrl(plan.dataset.productIdMonthly);
        });

        // Mutate V2 & V3 Radios
        document
          .querySelectorAll('.v2-hidden-radio, .v3-hidden-radio, input[name="v2_plan"]')
          .forEach(function (radio) {
            if (radio.dataset.url) radio.dataset.url = injectIntoUrl(radio.dataset.url);
          });

        // Mutate V4 & V5 Radios
        document.querySelectorAll('.v4-hidden-radio, .v5-hidden-radio').forEach(function (radio) {
          if (radio.dataset.urlUpfront) radio.dataset.urlUpfront = injectIntoUrl(radio.dataset.urlUpfront);
          if (radio.dataset.urlMonthly) radio.dataset.urlMonthly = injectIntoUrl(radio.dataset.urlMonthly);
        });
      } catch (error) {
        console.error('Failed to inject attribution into elements', error);
      }
    }
    function parseMoney(val) {
      return (
        Number(
          String(val || '0')
            .replace(/[^0-9.,-]/g, '')
            .replace(',', '.')
        ) || 0
      );
    }
    function fmtMoney(num, de) {
      var n = Number(num || 0);
      return de ? n.toFixed(2) + ' €' : '€' + n.toFixed(2);
    }
    function fmtMoneyRound(num, de) {
      var n = Number(num || 0);
      var isInt = Math.abs(n - Math.round(n)) < 0.005;
      if (de) return isInt ? Math.round(n) + ' €' : n.toFixed(2) + ' €';
      return isInt ? '€' + Math.round(n) : '€' + n.toFixed(2);
    }

    /* defer() — runs in idle time, falls back to setTimeout */
    function defer(fn, timeout) {
      if ('requestIdleCallback' in window) {
        requestIdleCallback(fn, { timeout: timeout || 2000 });
      } else {
        setTimeout(fn, timeout || 200);
      }
    }

    /* smartInterval() — pauses automatically when the tab is hidden */
    function smartInterval(fn, ms) {
      var id = null;
      function start() {
        if (!id) id = setInterval(fn, ms);
      }
      function stop() {
        if (id) {
          clearInterval(id);
          id = null;
        }
      }
      document.addEventListener('visibilitychange', function () {
        document.hidden ? stop() : start();
      });
      if (!document.hidden) start();
      return { start: start, stop: stop };
    }

    /* debounce() */
    function debounce(fn, wait) {
      var t;
      return function () {
        clearTimeout(t);
        t = setTimeout(fn, wait);
      };
    }

    /* ═══════════════════════════════════════════════════════════════
     DOM-DEPENDENT FEATURES
    ═══════════════════════════════════════════════════════════════ */
    function onReady() {
      /* Critical — must be interactive immediately */
      initPlanSection({
        containerSelector: '.main-offer-box',
        plansSelector: '.plan-option',
        planRadioClass: '.plan-radio',
        plansContainerId: '#plansContainer',
        addToCartSelector: '.add-to-cart-btn',
        testBtnSelector: '.test-btn-pdp',
        toggleId: 'billingToggle',
        toggleLabelClass: '.dynamic-toggle-label',
        summaryPrefix: 'summary',
        cartPrefix: 'cart',
        breakdownClass: '.plan-breakdown',
        ptbLineClass: '.ptb-line',
        isV2: false,
      });
      initCtaSave();
      initDiscount();
      initAttribution();
      /* Deferred — non-critical */
      defer(initCountdown, 500);
      defer(initGallery, 1000);
      defer(initSlider, 800);
      defer(initEstimatedDelivery, 800);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', onReady);
    } else {
      onReady();
    }

    /* ═══════════════════════════════════════════════════════════════
     PLAN SECTION — unified factory (For V1 Layout)
    ═══════════════════════════════════════════════════════════════ */
    function initPlanSection(cfg) {
      var rootEl = document.querySelector(cfg.containerSelector);
      if (!rootEl) return;
      var sectionContainer = (rootEl.closest && rootEl.closest('section')) || rootEl;

      var toggle = document.getElementById(cfg.toggleId);
      var toggleLabel = cfg.toggleLabelClass ? document.querySelector(cfg.toggleLabelClass) : null;
      var addToCartBtn = cfg.addToCartSelector ? document.querySelector(cfg.addToCartSelector) : null;
      var testButtons = cfg.testBtnSelector ? Array.from(document.querySelectorAll(cfg.testBtnSelector)) : [];
      var plans = Array.from(document.querySelectorAll(cfg.plansContainerId + ' ' + cfg.plansSelector));

      var planCache = plans.map(function (plan) {
        var radio = plan.querySelector(cfg.planRadioClass);
        return {
          el: plan,
          radio: radio,
          mpEl: plan.querySelector('.dynamic-monthly-price'),
          tpEl: plan.querySelector('.dynamic-total-price'),
          blEl: plan.querySelector('.dynamic-billing-label'),
          tpw: plan.querySelector('.total-price-wrapper'),
          stEl: plan.querySelector('.dynamic-subtotal-text'),
          ptbLine: cfg.ptbLineClass ? plan.querySelector(cfg.ptbLineClass) : null,
          breakdown: cfg.breakdownClass ? plan.querySelector(cfg.breakdownClass) : null,
          pills: Array.from(
            plan.querySelectorAll('.plan-top-pill, .plan-inner-pill, .plan-stock, .plan-side-icon, .plan-corner-icon')
          ),
          mpElV2: plan.querySelector('.monthly-price-v2'),
          totalElV2: plan.querySelector('.total-price-v2'),
          blElV2: plan.querySelector('.billing-label-v2'),
          pbReader: plan.querySelector('.pb-reader-amt'),
          pbPlan: plan.querySelector('.pb-plan-amt'),
          pbTotal: plan.querySelector('.pb-total-amt'),
          pbMonthly: plan.querySelector('.pb-monthly-amt'),
          pbNextLabel: plan.querySelector('.pb-next-label'),
          pbNextAmt: plan.querySelector('.pb-next-amt'),
          pbSave: plan.querySelector('.pb-save-amt'),
        };
      });

      var cartEls = cfg.cartPrefix
        ? {
            reader: document.querySelector('.' + cfg.cartPrefix + '-reader-amount'),
            planLabel: document.querySelector('.' + cfg.cartPrefix + '-plan-label'),
            plan: document.querySelector('.' + cfg.cartPrefix + '-plan-amount'),
            total: document.querySelector('.' + cfg.cartPrefix + '-total-amount'),
            recurring: document.querySelector('.' + cfg.cartPrefix + '-recurring-text'),
          }
        : null;
      var mainBox = document.querySelector('.main-offer-box');

      var selectedPlanUrl = '';

      function isYearly() {
        return toggle ? toggle.checked : true;
      }

      function isSectionVisible() {
        if (!sectionContainer) return false;
        var rect = sectionContainer.getBoundingClientRect();
        var style = window.getComputedStyle(sectionContainer);
        return style.display !== 'none' && style.visibility !== 'hidden' && rect.height > 0;
      }

      function getSelectedCache() {
        for (var i = 0; i < planCache.length; i++) {
          if (planCache[i].radio && planCache[i].radio.checked) return planCache[i];
        }
        return null;
      }

      function updateSelectedPlanUrl() {
        var yearly = isYearly();
        selectedPlanUrl = '';
        planCache.forEach(function (pc) {
          if (pc.radio && pc.radio.checked) {
            selectedPlanUrl = yearly ? pc.el.dataset.productIdYearly : pc.el.dataset.productIdMonthly;
          }
        });
        testButtons.forEach(function (btn) {
          if (btn && selectedPlanUrl) btn.setAttribute('href', selectedPlanUrl);
        });
        return selectedPlanUrl;
      }

      function toggleSavingsPills() {
        var yearly = isYearly();
        var allPills = document.querySelectorAll(
          cfg.plansContainerId +
            ' .desktop-pill, ' +
            cfg.plansContainerId +
            ' .mobile-pill, ' +
            cfg.plansContainerId +
            ' .savings-pill, ' +
            cfg.plansContainerId +
            ' .plan-inner-pill, ' +
            cfg.plansContainerId +
            ' .plan-top-pill, ' +
            cfg.plansContainerId +
            ' .plan-stock, ' +
            cfg.plansContainerId +
            ' .plan-side-icon, ' +
            cfg.plansContainerId +
            ' .plan-corner-icon'
        );
        allPills.forEach(function (pill) {
          pill.classList.toggle('hidden-by-js', !yearly);
        });
        planCache.forEach(function (pc) {
          var visible = !!pc.el.querySelector('.desktop-pill:not(.hidden-by-js), .savings-pill:not(.hidden-by-js)');
          pc.el.classList.toggle('has-pill', visible);
          pc.pills.forEach(function (el) {
            el.classList.toggle('hidden-when-monthly', !yearly);
          });
        });
      }

      function updatePlanTexts() {
        if (cfg.isV2) {
          updatePlanTextsV2();
          return;
        }
        var yearly = isYearly();
        if (toggleLabel) {
          toggleLabel.textContent = yearly
            ? isDE
              ? 'Vorab bezahlen'
              : 'Billed upfront'
            : isDE
            ? 'Monatlich zahlen'
            : 'Pay monthly';
        }
        planCache.forEach(function (pc) {
          var plan = pc.el;
          if (pc.tpw) pc.tpw.style.display = yearly ? 'inline-block' : 'none';
          if (pc.mpEl) {
            var price = yearly ? plan.dataset.monthlyPriceYearly : plan.dataset.monthlyPriceMonthly;
            pc.mpEl.textContent = isDE ? price + ' \u20ac' : '\u20ac' + price;
          }
          if (pc.tpEl) {
            var total = yearly ? plan.dataset.totalYearly : plan.dataset.totalMonthly;
            pc.tpEl.textContent = isDE ? total + ' \u20ac' : '\u20ac' + total;
          }
          if (pc.blEl) {
            pc.blEl.textContent = yearly ? (isDE ? 'Vorauszahlung:' : 'Billed upfront:') : '';
          }
          if (pc.stEl) {
            var sub = plan.dataset.subTotalMonthly;
            if (!yearly && sub) {
              pc.stEl.style.display = 'inline';
              pc.stEl.textContent = isDE ? ' Gesamt: ' + sub.trim() + ' \u20ac' : ' Total: \u20ac' + sub.trim();
            } else {
              pc.stEl.style.display = 'none';
            }
          }
        });
      }

      function updatePlanTextsV2() {
        var yearly = isYearly();
        if (toggleLabel) {
          toggleLabel.textContent = yearly
            ? isDE
              ? 'Vorab bezahlen'
              : 'Billed upfront'
            : isDE
            ? 'Monatlich zahlen'
            : 'Pay monthly';
        }
        planCache.forEach(function (pc) {
          var plan = pc.el;
          var mpY = plan.dataset.monthlyPriceYearly || '';
          var mpM = plan.dataset.monthlyPriceMonthly || '';
          var tY = plan.dataset.totalYearly || '';
          var tM = plan.dataset.totalMonthly || '';
          var stM = plan.dataset.subTotalMonthly || '';
          var mp = yearly ? mpY || mpM : mpM || mpY;

          if (pc.mpElV2 && mp) {
            pc.mpElV2.textContent = isDE ? mp + ' \u20ac' : '\u20ac' + mp;
          }

          var labelAmount = '';
          if (yearly) {
            labelAmount = tY;
          } else {
            labelAmount = stM || tM;
            if (!labelAmount && mp) {
              var months = parseInt(plan.dataset.months || '0', 10);
              var n = parseMoney(mp);
              if (months && n) labelAmount = (months * n).toString();
            }
          }
          if (pc.totalElV2) {
            pc.totalElV2.textContent = labelAmount ? (isDE ? labelAmount + ' \u20ac' : '\u20ac' + labelAmount) : '';
          }
          if (pc.blElV2) {
            var prefix = yearly ? (isDE ? 'Vorauszahlung:' : 'Billed upfront:') : isDE ? 'Gesamt:' : 'Total:';
            var first = pc.blElV2.firstChild;
            if (first && first.nodeType === Node.TEXT_NODE) {
              first.nodeValue = prefix + ' ';
            } else {
              pc.blElV2.insertBefore(document.createTextNode(prefix + ' '), pc.blElV2.firstChild || null);
            }
          }
        });
      }

      function updateInlinePayToday() {
        if (!mainBox || cfg.isV2) return;
        var readerPrice = parseMoney(mainBox.dataset.readerPrice || '99');
        var yearly = isYearly();
        planCache.forEach(function (pc) {
          if (!pc.ptbLine) return;
          var planNow = yearly ? parseMoney(pc.el.dataset.totalYearly) : parseMoney(pc.el.dataset.monthlyPriceMonthly);
          var payToday = readerPrice + planNow;
          var tw = isDE ? 'heute' : 'today';
          var sw = isDE ? 'Strips' : 'strips';
          var rw = isDE ? 'Reader' : 'reader';
          pc.ptbLine.textContent =
            fmtMoney(payToday, isDE) +
            ' ' +
            tw +
            ': (' +
            fmtMoney(planNow, isDE) +
            ' ' +
            sw +
            ' + ' +
            fmtMoney(readerPrice, isDE) +
            ' ' +
            rw +
            ')';
        });
      }

      function updateBreakdown() {
        if (!mainBox) return;
        var yearly = isYearly();
        var reader = parseMoney(mainBox.dataset.readerPrice || '99');
        var pc = getSelectedCache();

        planCache.forEach(function (p) {
          var bd = p.breakdown;
          if (!bd) return;
          bd.classList.toggle('active-breakdown', !!(p.radio && p.radio.checked));
          if (p !== pc) return;

          var months = parseInt(p.el.dataset.months || '0', 10);
          var mpY = parseMoney(p.el.dataset.monthlyPriceYearly);
          var tY = parseMoney(p.el.dataset.totalYearly);
          var mpM = parseMoney(p.el.dataset.monthlyPriceMonthly);
          var planNow = yearly ? tY : mpM;
          var total = reader + planNow;
          var monthly = yearly ? mpY : mpM;
          var saving = yearly ? mpM * months - tY : null;
          var nextLbl = yearly
            ? isDE
              ? 'N\u00e4chste Zahlung in ' + months + ' Monaten (nur Strips)'
              : 'Next payment in ' + months + ' months (strips only)'
            : isDE
            ? 'N\u00e4chste Zahlung n\u00e4chsten Monat (nur Strips)'
            : 'Next payment next month (strips only)';

          if (p.pbReader) p.pbReader.textContent = fmtMoney(reader, isDE);
          if (p.pbPlan) p.pbPlan.textContent = fmtMoney(planNow, isDE);
          if (p.pbTotal) p.pbTotal.textContent = fmtMoney(total, isDE);
          if (p.pbMonthly) p.pbMonthly.textContent = fmtMoney(monthly, isDE);
          if (p.pbNextLabel) p.pbNextLabel.textContent = nextLbl;
          if (p.pbNextAmt) p.pbNextAmt.textContent = fmtMoney(planNow, isDE);
          if (p.pbSave) p.pbSave.textContent = saving !== null ? fmtMoney(saving, isDE) : '\u2014';
        });
      }

      function refreshState() {
        if (!isSectionVisible()) return;
        updateSelectedPlanUrl();
        updatePlanTexts();
        if (!cfg.isV2) toggleSavingsPills();
        if (!cfg.isV2) updateInlinePayToday();
        if (!cfg.isV2) updateBreakdown();
      }

      planCache.forEach(function (pc) {
        if (!pc.radio) return;
        pc.radio.addEventListener('change', function () {
          updateSelectedPlanUrl();
          if (!cfg.isV2) updateInlinePayToday();
          if (!cfg.isV2) updateBreakdown();
          updateSelectedPlanUrl();
        });
      });

      if (toggle) {
        toggle.addEventListener('change', function () {
          updateSelectedPlanUrl();
          updatePlanTexts();
          if (!cfg.isV2) toggleSavingsPills();
          if (!cfg.isV2) updateInlinePayToday();
          if (!cfg.isV2) updateBreakdown();
        });
      }

   if (addToCartBtn) {
  addToCartBtn.addEventListener('click', function (e) {
    e.preventDefault();
    var url = updateSelectedPlanUrl();
    if (url && url !== '#') {
      var selected = getSelectedCache();
      var months = selected ? parseInt(selected.el.dataset.months, 10) : null;
      var upfront = isYearly();
      SELLING_PLAN_GUARD.resolve(url, months, upfront).then(function (finalUrl) {
        window.location.href = finalUrl;
      });
    } else {
      alert(isDE ? 'Bitte wählen Sie einen Plan aus.' : 'Please select a plan before continuing.');
    }
  });
}

testButtons.forEach(function (btn) {
  btn.addEventListener('click', function (e) {
    e.preventDefault();
    var url = updateSelectedPlanUrl();
    if (url && url !== '#') {
      var selected = getSelectedCache();
      var months = selected ? parseInt(selected.el.dataset.months, 10) : null;
      var upfront = isYearly();
      SELLING_PLAN_GUARD.resolve(url, months, upfront).then(function (finalUrl) {
        window.location.href = finalUrl;
      });
    } else {
      alert(isDE ? 'Bitte wählen Sie einen Plan aus.' : 'Please select a plan before continuing.');
    }
  });
});

      document.addEventListener('visibilitychange', refreshState);

      window.addEventListener(
        'resize',
        debounce(function () {
          if (!cfg.isV2) toggleSavingsPills();
        }, 16)
      );

      if (sectionContainer) {
        var mutObs = new MutationObserver(function (mutations) {
          mutations.forEach(function (m) {
            if (m.type === 'attributes' && (m.attributeName === 'style' || m.attributeName === 'class')) {
              if (isSectionVisible()) {
                updateSelectedPlanUrl();
                mutObs.disconnect();
              }
            }
          });
        });
        mutObs.observe(sectionContainer, {
          attributes: true,
          attributeFilter: ['style', 'class'],
        });
      }

      refreshState();
    }

    /* ═══════════════════════════════════════════════════════════════
     CTA SAVE AMOUNT
    ═══════════════════════════════════════════════════════════════ */
    function initCtaSave() {
      var toggle = document.getElementById('billingToggle');
      var btn = document.querySelector('.add-to-cart-btn');
      if (!btn) return;

      var saveEl = btn.querySelector('.cta-save-amount');
      if (!saveEl) {
        saveEl = document.createElement('span');
        saveEl.className = 'cta-save-amount';
        saveEl.setAttribute('aria-hidden', 'true');
        btn.appendChild(saveEl);
      }

      function updateCtaSave() {
        var selected = document.querySelector('#plansContainer .plan-radio:checked');
        var plan = selected ? selected.closest('.plan-option') : null;
        var yearly = toggle ? toggle.checked : true;

        if (!plan || !yearly) {
          saveEl.textContent = '';
          return;
        }
        var months = parseInt(plan.dataset.months || '0', 10);
        var mpm = parseMoney(plan.dataset.monthlyPriceMonthly);
        var ty = parseMoney(plan.dataset.totalYearly);
        if (!months || !mpm || !ty) {
          saveEl.textContent = '';
          return;
        }

        var saving = months * mpm - ty;
        if (saving > 0) {
          saveEl.textContent = isDE
            ? '& ' + Math.round(saving) + ' \u20ac Sparen'
            : '& Save \u20ac' + Math.round(saving);
        } else {
          saveEl.textContent = '';
        }
      }

      updateCtaSave();
      document.querySelectorAll('#plansContainer .plan-radio').forEach(function (r) {
        r.addEventListener('change', updateCtaSave);
      });
      if (toggle) toggle.addEventListener('change', updateCtaSave);
    }

    /* ═══════════════════════════════════════════════════════════════
     IMAGE SLIDER
    ═══════════════════════════════════════════════════════════════ */
    function initSlider() {
      var track = document.querySelector('.inne-slider-track');
      if (!track) return;

      function setupSlider() {
        var rawSlides = document.querySelectorAll('.inne-slider-item');
        var rawDots = document.querySelectorAll('.inne-dot');

        if (rawSlides.length >= 6) {
          rawSlides[4].style.display = 'none';
          rawSlides[5].style.display = 'none';
          if (rawDots[4]) rawDots[4].style.display = 'none';
          if (rawDots[5]) rawDots[5].style.display = 'none';
        }

        var slides = Array.from(rawSlides).filter(function (el) {
          return el.style.display !== 'none';
        });
        var dots = Array.from(rawDots).filter(function (el) {
          return el.style.display !== 'none';
        });
        var prevBtn = document.querySelector('.inne-slider-prev');
        var nextBtn = document.querySelector('.inne-slider-next');
        var slideCount = slides.length;
        var currentIndex = 0;
        var startX = 0;
        var isSwiping = false;

        function showSlide(index) {
          if (!slideCount) return;
          if (index < 0) index = slideCount - 1;
          if (index >= slideCount) index = 0;
          track.style.transform = 'translateX(' + -index * 100 + '%)';
          dots.forEach(function (dot, i) {
            dot.classList.toggle('active', i === index);
          });
          currentIndex = index;
        }

        dots.forEach(function (dot, i) {
          dot.addEventListener('click', function () {
            showSlide(i);
          });
        });
        if (prevBtn)
          prevBtn.addEventListener('click', function () {
            showSlide(currentIndex - 1);
          });
        if (nextBtn)
          nextBtn.addEventListener('click', function () {
            showSlide(currentIndex + 1);
          });

        track.addEventListener(
          'touchstart',
          function (e) {
            startX = e.touches[0].clientX;
            isSwiping = true;
          },
          { passive: true }
        );
        track.addEventListener(
          'touchmove',
          function (e) {
            if (!isSwiping) return;
            var diff = startX - e.touches[0].clientX;
            if (Math.abs(diff) > 50) {
              showSlide(diff > 0 ? currentIndex + 1 : currentIndex - 1);
              isSwiping = false;
            }
          },
          { passive: true }
        );
        track.addEventListener(
          'touchend',
          function () {
            isSwiping = false;
          },
          { passive: true }
        );

        showSlide(0);
      }

      if ('IntersectionObserver' in window) {
        var sliderObs = new IntersectionObserver(
          function (entries) {
            if (entries[0].isIntersecting) {
              setupSlider();
              sliderObs.disconnect();
            }
          },
          { threshold: 0.1 }
        );
        sliderObs.observe(track);
      } else {
        setupSlider();
      }
    }

/* ═══════════════════════════════════════════════════════════════
     DISCOUNT CODE
    ═══════════════════════════════════════════════════════════════ */
    function initDiscount() {
      function cookieDiscount() {
        var match = document.cookie.match(/(?:^|; )discount_code=([^;]*)/);
        if (!match) return '';
        try {
          return decodeURIComponent(match[1].replace(/\+/g, ' ')).trim();
        } catch (e) {
          return match[1];
        }
      }

      function readStoredDiscount() {
        try {
          var code = localStorage.getItem('discount_code');
          if (!code) return '';
          var ts = parseInt(localStorage.getItem('discount_code_at') || '0', 10);
          if (!ts || Date.now() - ts > 24 * 60 * 60 * 1000) {
            localStorage.removeItem('discount_code');
            localStorage.removeItem('discount_code_at');
            return '';
          }
          return code;
        } catch (e) {
          return '';
        }
      }

      function writeStoredDiscount(code) {
        try {
          localStorage.setItem('discount_code', code);
          localStorage.setItem('discount_code_at', String(Date.now()));
        } catch (e) {}
      }

      var storedDiscount =
        new URLSearchParams(window.location.search).get('discount') ||
        cookieDiscount() ||
        window.__welcomePageDiscount ||
        readStoredDiscount();
      if (!storedDiscount) return;
      writeStoredDiscount(storedDiscount);

      // Replace cart codes (GET /discount/CODE adds another and the better one wins).
      fetch('/cart/update.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ discount: storedDiscount }),
      }).catch(function () {});

      // 2. Append discount param to ALL plan checkout URLs in data attributes
      //    so when updateSelectedPlanUrl() reads them, discount is already included
      document.querySelectorAll('.plan-option, .plan-option-v2').forEach(function (plan) {
        ['productIdYearly', 'productIdMonthly'].forEach(function (key) {
          var url = plan.dataset[key];
          if (!url || url === '#') return;
          try {
            var u = new URL(url, window.location.origin);
            u.searchParams.set('discount', storedDiscount);
            plan.dataset[key] = u.toString();
          } catch (e) {
            var sep = url.indexOf('?') !== -1 ? '&' : '?';
            plan.dataset[key] = url + sep + 'discount=' + encodeURIComponent(storedDiscount);
          }
        });
      });

      // 3. Same for V4/V5/V6/V7 hidden radios (upfront + monthly checkout URLs)
      document
        .querySelectorAll('.v4-hidden-radio, .v5-hidden-radio, .v6-hidden-radio, .v7-hidden-radio')
        .forEach(function (radio) {
          ['urlUpfront', 'urlMonthly'].forEach(function (key) {
            var url = radio.dataset[key];
            if (!url || url === '#') return;
            try {
              var u = new URL(url, window.location.origin);
              u.searchParams.set('discount', storedDiscount);
              radio.dataset[key] = u.toString();
            } catch (e) {
              var sep = url.indexOf('?') !== -1 ? '&' : '?';
              radio.dataset[key] = url + sep + 'discount=' + encodeURIComponent(storedDiscount);
            }
          });
        });
    }

    /* ═══════════════════════════════════════════════════════════════
     COUNTDOWN TIMER
    ═══════════════════════════════════════════════════════════════ */
    function initCountdown() {
      var el = document.getElementById('countdown');
      if (!el) return;

      var DURATION = 4 * 3600000;
      var KEY = 'custom_4hr_countdown_end';

      function getEnd() {
        var end = parseInt(localStorage.getItem(KEY), 10);
        if (!end || Date.now() >= end) {
          end = Date.now() + DURATION;
          localStorage.setItem(KEY, end);
        }
        return end;
      }
      function tick() {
        var rem = getEnd() - Date.now();
        if (rem <= 0) {
          localStorage.setItem(KEY, Date.now() + DURATION);
          rem = DURATION;
        }
        var h = Math.floor(rem / 3600000);
        var m = Math.floor((rem % 3600000) / 60000);
        var s = Math.floor((rem % 60000) / 1000);
        el.textContent = (h < 10 ? '0' : '') + h + ':' + (m < 10 ? '0' : '') + m + ':' + (s < 10 ? '0' : '') + s;
      }

      var countdownInterval = null;
      if ('IntersectionObserver' in window) {
        var obs = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              if (entry.isIntersecting) {
                tick();
                if (!countdownInterval) countdownInterval = setInterval(tick, 1000);
              } else {
                if (countdownInterval) {
                  clearInterval(countdownInterval);
                  countdownInterval = null;
                }
              }
            });
          },
          { threshold: 0 }
        );
        obs.observe(el);
      } else {
        tick();
        countdownInterval = setInterval(tick, 1000);
      }
    }

    /* ═══════════════════════════════════════════════════════════════
     GALLERY
    ═══════════════════════════════════════════════════════════════ */
    function initGallery() {
      document.querySelectorAll('.inne-gallery').forEach(function (gallery) {
        var mainImg = gallery.querySelector('.ig-main-img');
        var thumbs = gallery.querySelectorAll('.ig-thumb');
        if (!mainImg || !thumbs.length) return;

        function select(index) {
          var prev = gallery.querySelector('.ig-thumb[aria-selected="true"]');
          if (prev) {
            prev.setAttribute('aria-selected', 'false');
            prev.classList.remove('is-active');
          }
          var next = gallery.querySelector('.ig-thumb[data-index="' + index + '"]');
          if (!next) return;
          mainImg.src = next.getAttribute('data-full');
          mainImg.alt = next.getAttribute('data-alt') || '';
          next.setAttribute('aria-selected', 'true');
          next.classList.add('is-active');
        }

        thumbs.forEach(function (btn) {
          btn.addEventListener('click', function () {
            select(parseInt(btn.dataset.index, 10));
          });
          btn.addEventListener('keydown', function (e) {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              btn.click();
            }
          });
        });

        var preloadFn = function () {
          thumbs.forEach(function (btn) {
            var img = new Image();
            img.src = btn.getAttribute('data-full');
          });
        };
        if ('requestIdleCallback' in window) {
          requestIdleCallback(preloadFn, { timeout: 15000 });
        } else {
          setTimeout(preloadFn, 10000);
        }
      });
    }

    /* ═══════════════════════════════════════════════════════════════
     ESTIMATED DELIVERY
    ═══════════════════════════════════════════════════════════════ */
    function initEstimatedDelivery() {
      var blocks = document.querySelectorAll('.product_estimated-delivery');
      if (!blocks.length) return;
      var MN = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
      var locale = (document.documentElement.lang || 'en').split('-')[0];

      blocks.forEach(function (block) {
        var dateSpan = block.querySelector('.product_estimated-delivery-date');
        if (!dateSpan) return;
        var daysToAdd = parseInt(block.getAttribute('data-days-to-add'), 10);
        if (isNaN(daysToAdd)) daysToAdd = 3;
        var est = new Date();
        est.setDate(est.getDate() + daysToAdd);
        var formatted;
        try {
          formatted = est.toLocaleDateString(locale, { month: 'short', day: 'numeric' });
        } catch (e) {
          formatted = MN[est.getMonth()] + ' ' + est.getDate();
        }
        dateSpan.textContent = ' ' + formatted;
      });
    }

    /* ═══════════════════════════════════════════════════════════════
     NEW V4 DESIGN LOGIC 
  ═══════════════════════════════════════════════════════════════ */

    function initV4Logic() {
      var v4Container = document.querySelector('.right-column-v4');
      if (!v4Container) return;

      var cards = v4Container.querySelectorAll('.v4-plan-card');
      var showBtn = document.getElementById('v4-show-options');
      var ctaBtn = document.getElementById('v4-add-to-cart');
      var v4Toggle = document.getElementById('v4-billingToggle');
      var v4ToggleLabel = document.getElementById('v4-toggle-label');

      var isDE = (document.documentElement.lang || '').toLowerCase().indexOf('de') === 0;

      if (!cards.length || !ctaBtn) return;

      // Inject the special 24-month promo badge dynamically via JavaScript
      cards.forEach(function (card) {
        var titleEl = card.querySelector('.v4-title');
        if (titleEl && titleEl.textContent.indexOf('24') !== -1) {
          var existingBadge = card.querySelector('.v4-special-promo-badge');
          if (!existingBadge) {
            var badge = document.createElement('div');
            badge.className = 'v4-special-promo-badge';
            badge.style.display = 'none';
            badge.innerHTML = isDE ? 'FREE READER <s>99€</s> — BESTES ANGEBOT' : 'FREE READER <s>99€</s> — BEST VALUE';
            card.insertBefore(badge, card.firstChild);
          }
        }
      });

      // Toggle hidden options (6 & 24 Months)
      var isExpanded = false;
      if (showBtn) {
        showBtn.addEventListener('click', function (e) {
          e.preventDefault();
          isExpanded = !isExpanded;

          cards.forEach(function (card) {
            if (!card.classList.contains('v4-default-visible')) {
              if (isExpanded) {
                card.classList.remove('is-hidden-plan');
              } else {
                card.classList.add('is-hidden-plan');
              }
            }
          });

          if (isExpanded) {
            showBtn.textContent = showBtn.getAttribute('data-text-less');
          } else {
            showBtn.textContent = showBtn.getAttribute('data-text-more');
          }
        });
      }

      // Card selection
      cards.forEach(function (card) {
        card.addEventListener('click', function () {
          cards.forEach(function (c) {
            c.classList.remove('is-active');
          });
          card.classList.add('is-active');

          var radio = card.querySelector('.v4-hidden-radio');
          if (radio) radio.checked = true;

          updateV4CheckoutUrl();
        });
      });

      // Handle Upfront/Monthly Toggle Switch
      function updateV4Pricing() {
        var isUpfront = v4Toggle ? v4Toggle.checked : true;

        // Update toggle label
        if (v4ToggleLabel) {
          v4ToggleLabel.textContent = isUpfront
            ? isDE
              ? 'Vorab bezahlen'
              : 'Billed upfront'
            : isDE
            ? 'Monatlich zahlen'
            : 'Pay monthly';
        }

        var desktopBanners = document.querySelectorAll('#ml-promo-promo_banner_UhGbgr, .ml-promo-banner--left');
        var mobileBanners = document.querySelectorAll('#ml-promo-promo_banner_M9yVDk, .ml-promo-banner--right');
        var isMobile = window.innerWidth <= 767;

        var extraDesktopBanner = document.getElementById('ml-promo-promo_banner_UgkVfQ');
        var extraMobileBanner = document.getElementById('ml-promo-promo_banner_e4w3Di');
        if (extraDesktopBanner) extraDesktopBanner.style.setProperty('display', 'none', 'important');
        if (extraMobileBanner) extraMobileBanner.style.setProperty('display', 'none', 'important');

        if (isUpfront) {
          desktopBanners.forEach(function (b) {
            if (b.id !== 'ml-promo-promo_banner_UgkVfQ') {
              b.style.setProperty('display', isMobile ? 'none' : 'flex', 'important');
            }
          });
          mobileBanners.forEach(function (b) {
            if (b.id !== 'ml-promo-promo_banner_e4w3Di') {
              b.style.setProperty('display', isMobile ? 'flex' : 'none', 'important');
            }
          });
        } else {
          desktopBanners.forEach(function (b) {
            b.style.setProperty('display', 'none', 'important');
          });
          mobileBanners.forEach(function (b) {
            b.style.setProperty('display', 'none', 'important');
          });
        }

        // Update prices in cards
        cards.forEach(function (card) {
          var priceEl = card.querySelector('.dynamic-v4-price');
          var billingEl = card.querySelector('.dynamic-v4-billing');
          var subpriceEl = card.querySelector('.dynamic-v4-subprice');
          var savingsEl = card.querySelector('.dynamic-v4-savings');

          var badgeEl = card.querySelector('.v4-badge');
          var savingsRowEl = card.querySelector('.v4-savings-row');
          var specialPromoBadge = card.querySelector('.v4-special-promo-badge');

          if (priceEl) priceEl.textContent = isUpfront ? priceEl.dataset.upfront : priceEl.dataset.monthly;
          if (billingEl) billingEl.textContent = isUpfront ? billingEl.dataset.upfront : billingEl.dataset.monthly;
          if (subpriceEl) subpriceEl.textContent = isUpfront ? subpriceEl.dataset.upfront : subpriceEl.dataset.monthly;
          if (savingsEl) savingsEl.textContent = isUpfront ? savingsEl.dataset.upfront : savingsEl.dataset.monthly;

          if (badgeEl) {
            badgeEl.style.display = isUpfront ? 'block' : 'none';
          }
          if (savingsRowEl) {
            savingsRowEl.style.display = isUpfront ? 'flex' : 'none';
          }

          // Toggle the 24-month special promo badge visibility based on billing cycle
          if (specialPromoBadge) {
            specialPromoBadge.style.display = isUpfront ? 'block' : 'none';
          }
        });

        updateV4CheckoutUrl();
      }

      // Update CTA checkout link
      function updateV4CheckoutUrl() {
        var activeCard = v4Container.querySelector('.v4-plan-card.is-active') || cards[0];
        var radio = activeCard.querySelector('.v4-hidden-radio');
        if (!radio) return;

        var isUpfront = v4Toggle ? v4Toggle.checked : true;
        var url = isUpfront ? radio.dataset.urlUpfront : radio.dataset.urlMonthly;

        if (url) {
          ctaBtn.href = url;
        } else {
          ctaBtn.href = '#';
        }
      }

      if (v4Toggle) {
        v4Toggle.addEventListener('change', updateV4Pricing);
      }

      window.addEventListener('resize', updateV4Pricing);

      // YAHAN FIX ADD KIYA GAYA HAI: setTimeout ki wajah se browser back button state theek se read karega
      window.addEventListener('pageshow', function () {
        setTimeout(function () {
          updateV4Pricing();
        }, 100);
      });

      updateV4Pricing();
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initV4Logic);
    } else {
      initV4Logic();
    }

    /* ═══════════════════════════════════════════════════════════════
     NEW V5 DESIGN LOGIC 
  ═══════════════════════════════════════════════════════════════ */
    function initV5Logic() {
      var v5Container = document.querySelector('.right-column-v5');
      if (!v5Container) return;

      var cards = v5Container.querySelectorAll('.v5-plan-card');
      var ctaBtn = document.getElementById('v5-add-to-cart');
      var v5Toggle = document.getElementById('v5-billingToggle');
      var v5ToggleLabel = document.getElementById('v5-toggle-label');
      var v5SavingsPill = document.getElementById('v5-savings-pill');

      var isDE = (document.documentElement.lang || '').toLowerCase().indexOf('de') === 0;

      if (!cards.length || !ctaBtn) return;

      // Inject the special 24-month promo badge dynamically via JavaScript
      cards.forEach(function (card) {
        var titleEl = card.querySelector('.dynamic-v5-title');
        if (titleEl && titleEl.dataset.upfront && titleEl.dataset.upfront.indexOf('24') !== -1) {
          var existingBadge = card.querySelector('.v5-special-promo-badge');
          if (!existingBadge) {
            var badge = document.createElement('div');
            badge.className = 'v5-special-promo-badge';
            badge.style.display = 'none';
            badge.innerHTML = isDE ? 'FREE READER <s>99€</s> — BESTES ANGEBOT' : 'FREE READER <s>99€</s> — BEST VALUE';
            card.insertBefore(badge, card.firstChild);
          }
        }
      });

      // Handle card selection
      cards.forEach(function (card) {
        card.addEventListener('click', function () {
          cards.forEach(function (c) {
            c.classList.remove('is-active');
          });
          card.classList.add('is-active');

          var radio = card.querySelector('.v5-hidden-radio');
          if (radio) radio.checked = true;

          updateV5Pricing();
        });
      });

      // Update prices, texts, banners, savings pill, and special badges
      function updateV5Pricing() {
        var isUpfront = v5Toggle ? v5Toggle.checked : true;

        // Update toggle label
        if (v5ToggleLabel) {
          v5ToggleLabel.textContent = isUpfront
            ? isDE
              ? 'Vorab bezahlen'
              : 'Billed upfront'
            : isDE
            ? 'Monatlich zahlen'
            : 'Pay monthly';
        }

        // Banner display logic
        var desktopBanners = document.querySelectorAll('#ml-promo-promo_banner_UhGbgr, .ml-promo-banner--left');
        var mobileBanners = document.querySelectorAll('#ml-promo-promo_banner_M9yVDk, .ml-promo-banner--right');
        var isMobile = window.innerWidth <= 767;

        var extraDesktopBanner = document.getElementById('ml-promo-promo_banner_UgkVfQ');
        var extraMobileBanner = document.getElementById('ml-promo-promo_banner_e4w3Di');

        if (extraDesktopBanner) extraDesktopBanner.style.setProperty('display', 'none', 'important');
        if (extraMobileBanner) extraMobileBanner.style.setProperty('display', 'none', 'important');

        if (isUpfront) {
          desktopBanners.forEach(function (b) {
            if (b.id !== 'ml-promo-promo_banner_UgkVfQ') {
              b.style.setProperty('display', isMobile ? 'none' : 'flex', 'important');
            }
          });
          mobileBanners.forEach(function (b) {
            if (b.id !== 'ml-promo-promo_banner_e4w3Di') {
              b.style.setProperty('display', isMobile ? 'flex' : 'none', 'important');
            }
          });
        } else {
          desktopBanners.forEach(function (b) {
            b.style.setProperty('display', 'none', 'important');
          });
          mobileBanners.forEach(function (b) {
            b.style.setProperty('display', 'none', 'important');
          });
        }

        // Update data inside cards
        cards.forEach(function (card) {
          var titleEl = card.querySelector('.dynamic-v5-title');
          var priceEl = card.querySelector('.dynamic-v5-price');
          var subtitleEl = card.querySelector('.dynamic-v5-subtitle');
          var subpriceEl = card.querySelector('.dynamic-v5-subprice');
          var specialPromoBadge = card.querySelector('.v5-special-promo-badge');

          if (titleEl) titleEl.textContent = isUpfront ? titleEl.dataset.upfront : titleEl.dataset.monthly;
          if (priceEl) priceEl.textContent = isUpfront ? priceEl.dataset.upfront : priceEl.dataset.monthly;
          if (subtitleEl) subtitleEl.textContent = isUpfront ? subtitleEl.dataset.upfront : subtitleEl.dataset.monthly;
          if (subpriceEl) subpriceEl.textContent = isUpfront ? subpriceEl.dataset.upfront : subpriceEl.dataset.monthly;

          // Toggle the 24-month special promo badge visibility based on billing cycle
          if (specialPromoBadge) {
            specialPromoBadge.style.display = isUpfront ? 'block' : 'none';
          }
        });

        // Update active card savings pill and checkout URL
        var activeCard = v5Container.querySelector('.v5-plan-card.is-active') || cards[0];
        var radio = activeCard.querySelector('.v5-hidden-radio');

        if (radio) {
          var url = isUpfront ? radio.dataset.urlUpfront : radio.dataset.urlMonthly;
          ctaBtn.href = url ? url : '#';

          var savingsText = isUpfront ? radio.dataset.savingsUpfront : radio.dataset.savingsMonthly;
          if (v5SavingsPill) {
            if (savingsText && savingsText.trim() !== '') {
              v5SavingsPill.textContent = savingsText;
              v5SavingsPill.style.display = 'inline-block';
            } else {
              v5SavingsPill.style.display = 'none';
            }
          }
        }
      }

      // Attach event listeners for state changes
      if (v5Toggle) {
        v5Toggle.addEventListener('change', updateV5Pricing);
      }

      window.addEventListener('resize', updateV5Pricing);
      window.addEventListener('pageshow', function () {
        updateV5Pricing();
      });

      // Initialize layout on load
      updateV5Pricing();
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initV5Logic);
    } else {
      initV5Logic();
    }

    /* ═══════════════════════════════════════════════════════════════
     NEW V6 DESIGN LOGIC 
═══════════════════════════════════════════════════════════════ */
    function initV6Logic() {
      var v6Container = document.querySelector('.right-column-v6');
      if (!v6Container) return;

      var cards = v6Container.querySelectorAll('.v6-plan-card');
      var ctaBtn = document.getElementById('v6-add-to-cart');
      var v6Toggle = document.getElementById('v6-billingToggle');
      var v6ToggleLabel = document.getElementById('v6-toggle-label');

      var isDE = (document.documentElement.lang || '').toLowerCase().indexOf('de') === 0;

      if (!cards.length || !ctaBtn) return;

      // Handle card selection
      cards.forEach(function (card) {
        card.addEventListener('click', function () {
          cards.forEach(function (c) {
            c.classList.remove('is-active');
          });
          card.classList.add('is-active');

          var radio = card.querySelector('.v6-hidden-radio');
          if (radio) radio.checked = true;

          updateV6Pricing();
        });
      });

      // Update prices, texts, and banners
      function updateV6Pricing() {
        var isUpfront = v6Toggle ? v6Toggle.checked : true;

        // Update toggle label
        if (v6ToggleLabel) {
          v6ToggleLabel.textContent = isUpfront
            ? isDE
              ? 'Vorab bezahlen'
              : 'Billed upfront'
            : isDE
            ? 'Monatlich zahlen'
            : 'Pay monthly';
        }

        // Banner display logic (Matches V4 & V5 logic)
        var desktopBanners = document.querySelectorAll('#ml-promo-promo_banner_UhGbgr, .ml-promo-banner--left');
        var mobileBanners = document.querySelectorAll('#ml-promo-promo_banner_M9yVDk, .ml-promo-banner--right');
        var isMobile = window.innerWidth <= 767;

        var extraDesktopBanner = document.getElementById('ml-promo-promo_banner_UgkVfQ');
        var extraMobileBanner = document.getElementById('ml-promo-promo_banner_e4w3Di');

        if (extraDesktopBanner) extraDesktopBanner.style.setProperty('display', 'none', 'important');
        if (extraMobileBanner) extraMobileBanner.style.setProperty('display', 'none', 'important');

        if (isUpfront) {
          desktopBanners.forEach(function (b) {
            if (b.id !== 'ml-promo-promo_banner_UgkVfQ') {
              b.style.setProperty('display', isMobile ? 'none' : 'flex', 'important');
            }
          });
          mobileBanners.forEach(function (b) {
            if (b.id !== 'ml-promo-promo_banner_e4w3Di') {
              b.style.setProperty('display', isMobile ? 'flex' : 'none', 'important');
            }
          });
        } else {
          desktopBanners.forEach(function (b) {
            b.style.setProperty('display', 'none', 'important');
          });
          mobileBanners.forEach(function (b) {
            b.style.setProperty('display', 'none', 'important');
          });
        }

        // Update data inside cards
        cards.forEach(function (card) {
          var titleEl = card.querySelector('.dynamic-v6-title');
          var priceEl = card.querySelector('.dynamic-v6-price');
          var readerTextEl = card.querySelector('.dynamic-v6-reader-text');
          var stripTextEl = card.querySelector('.dynamic-v6-strip-text');
          var stripPriceEl = card.querySelector('.dynamic-v6-strip-price');
          var readerPriceEl = card.querySelector('.dynamic-v6-reader-price');

          // --- NEW LINE: Badge Hide/Show Logic ---
          var cardBadge = card.querySelector('.v6-card-badge');
          if (cardBadge) {
            cardBadge.style.display = isUpfront ? 'block' : 'none';
          }

          if (titleEl) titleEl.innerHTML = isUpfront ? titleEl.dataset.upfront : titleEl.dataset.monthly;
          if (priceEl) priceEl.innerHTML = isUpfront ? priceEl.dataset.upfront : priceEl.dataset.monthly;
          if (readerTextEl)
            readerTextEl.innerHTML = isUpfront ? readerTextEl.dataset.upfront : readerTextEl.dataset.monthly;
          if (stripTextEl)
            stripTextEl.innerHTML = isUpfront ? stripTextEl.dataset.upfront : stripTextEl.dataset.monthly;
          if (stripPriceEl)
            stripPriceEl.innerHTML = isUpfront ? stripPriceEl.dataset.upfront : stripPriceEl.dataset.monthly;

          // Custom Logic for Reader Price Cut & Gratis Text
          if (readerPriceEl) {
            var rPrice = isUpfront ? readerPriceEl.dataset.upfrontPrice : readerPriceEl.dataset.monthlyPrice;
            var rDiscount = isUpfront ? readerPriceEl.dataset.upfrontDiscount : readerPriceEl.dataset.monthlyDiscount;

            if (rDiscount && rDiscount.trim() !== '') {
              readerPriceEl.innerHTML =
                "<s style='opacity: 0.6; font-weight: normal; margin-right: 5px;'>" +
                rPrice +
                "</s> <span style='color:#F2853C; font-weight:700;'>" +
                rDiscount +
                '</span>';
            } else {
              readerPriceEl.innerHTML = rPrice;
            }
          }
        });

        // Update checkout URL
        var activeCard = v6Container.querySelector('.v6-plan-card.is-active') || cards[0];
        var radio = activeCard.querySelector('.v6-hidden-radio');

        if (radio) {
          var url = isUpfront ? radio.dataset.urlUpfront : radio.dataset.urlMonthly;
          ctaBtn.href = url ? url : '#';
        }
      }

      // Attach event listeners for state changes
      if (v6Toggle) {
        v6Toggle.addEventListener('change', updateV6Pricing);
      }

      window.addEventListener('resize', updateV6Pricing);
      window.addEventListener('pageshow', function () {
        updateV6Pricing();
      });

      // Initialize layout on load
      updateV6Pricing();
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initV6Logic);
    } else {
      initV6Logic();
    }

    /* ═══════════════════════════════════════════════════════════════
       NEW V7 DESIGN LOGIC & TIMER
    ═══════════════════════════════════════════════════════════════ */
    function initV7Logic() {
      document.querySelectorAll('.right-column-v7').forEach(initV7ForContainer);
    }

    function initV7ForContainer(v7Container) {
      if (v7Container.getAttribute('data-v7-inited') === 'true') return;
      v7Container.setAttribute('data-v7-inited', 'true');

      var cards = v7Container.querySelectorAll('.v7-plan-card');
      var ctaBtn = v7Container.querySelector('.v7-checkout-btn');
      var v7Toggle = v7Container.querySelector('.v7-billing-input');
      var v7Tabs = v7Container.querySelectorAll('.v7-toggle-tab');
      var bannerSub = v7Container.querySelector('.v7-first-order-sub');

      var isDE = (document.documentElement.lang || '').toLowerCase().indexOf('de') === 0;

      if (!cards.length || !ctaBtn) return;

      function v7Attr(el, isUpfront) {
        if (!el) return '';
        var named = el.getAttribute(isUpfront ? 'data-price-upfront' : 'data-price-monthly');
        if (named != null && named !== '') return named;
        return el.getAttribute(isUpfront ? 'data-upfront' : 'data-monthly') || '';
      }

      cards.forEach(function (card) {
        card.addEventListener('click', function () {
          cards.forEach(function (c) {
            c.classList.remove('is-active');
          });
          card.classList.add('is-active');
          var radio = card.querySelector('.v7-hidden-radio');
          if (radio) radio.checked = true;
          updateV7Pricing();
        });
      });

      v7Tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          if (v7Toggle) v7Toggle.checked = tab.getAttribute('data-mode') === 'upfront';
          updateV7Pricing();
        });
      });

      function updateV7Pricing() {
        var isUpfront = v7Toggle ? v7Toggle.checked : true;

        v7Tabs.forEach(function (tab) {
          var isUpTab = tab.getAttribute('data-mode') === 'upfront';
          tab.classList.toggle('is-active', isUpfront ? isUpTab : !isUpTab);
        });

        if (bannerSub) {
          bannerSub.textContent = isUpfront ? bannerSub.dataset.upfront || '' : bannerSub.dataset.monthly || '';
        }

        // --- ADDED BANNER TOGGLE LOGIC TO V7 ---
        var desktopBanners = document.querySelectorAll('#ml-promo-promo_banner_UhGbgr, .ml-promo-banner--left');
        var mobileBanners = document.querySelectorAll('#ml-promo-promo_banner_M9yVDk, .ml-promo-banner--right');
        var isMobile = window.innerWidth <= 767;

        var extraDesktopBanner = document.getElementById('ml-promo-promo_banner_UgkVfQ');
        var extraMobileBanner = document.getElementById('ml-promo-promo_banner_e4w3Di');

        if (extraDesktopBanner) extraDesktopBanner.style.setProperty('display', 'none', 'important');
        if (extraMobileBanner) extraMobileBanner.style.setProperty('display', 'none', 'important');

        if (isUpfront) {
          desktopBanners.forEach(function (b) {
            if (b.id !== 'ml-promo-promo_banner_UgkVfQ') {
              b.style.setProperty('display', isMobile ? 'none' : 'flex', 'important');
            }
          });
          mobileBanners.forEach(function (b) {
            if (b.id !== 'ml-promo-promo_banner_e4w3Di') {
              b.style.setProperty('display', isMobile ? 'flex' : 'none', 'important');
            }
          });
        } else {
          desktopBanners.forEach(function (b) {
            b.style.setProperty('display', 'none', 'important');
          });
          mobileBanners.forEach(function (b) {
            b.style.setProperty('display', 'none', 'important');
          });
        }

        v7Container.classList.toggle('is-billing-upfront', isUpfront);
        v7Container.classList.toggle('is-billing-monthly', !isUpfront);

        cards.forEach(function (card) {
          var headlineEl = card.querySelector('.v7-dyn-headline');
          var subtextEl = card.querySelector('.v7-dyn-price-subtext');

          // Badge only on upfront unless the plan opts into monthly
          var cardBadge = card.querySelector('.v7-card-badge, .v7-special-promo-badge');
          if (cardBadge) {
            var showOnMonthly = cardBadge.getAttribute('data-badge-monthly') === 'true';
            cardBadge.style.display = isUpfront || showOnMonthly ? 'block' : 'none';
          }

          if (headlineEl) headlineEl.textContent = v7Attr(headlineEl, isUpfront);

          if (subtextEl) {
            var subVal = isUpfront ? subtextEl.dataset.upfront || '' : subtextEl.dataset.monthly || '';
            subtextEl.textContent = subVal;
            subtextEl.style.display = subVal.trim() !== '' ? '' : 'none';
          }
        });

        var activeCard = v7Container.querySelector('.v7-plan-card.is-active') || cards[0];
        var radio = activeCard.querySelector('.v7-hidden-radio');
        if (radio) {
          var url = isUpfront ? radio.dataset.urlUpfront : radio.dataset.urlMonthly;
          ctaBtn.href = url ? url : '#';
        }
      }

      if (v7Toggle) v7Toggle.addEventListener('change', updateV7Pricing);
      window.addEventListener('resize', updateV7Pricing);
      window.addEventListener('pageshow', function () {
        setTimeout(updateV7Pricing, 100);
      });
      updateV7Pricing();
    }

function initV7Timer() {
      var hEl = document.getElementById('v7-hours');
      var mEl = document.getElementById('v7-mins');
      var sEl = document.getElementById('v7-secs');
      if (!hEl) return;

      var DURATION = 12 * 3600000; // 12 hours
      var KEY = 'v7_timer_end';
      var DURKEY = 'v7_timer_duration';

      var storedDuration = parseInt(localStorage.getItem(DURKEY), 10);
      var target = parseInt(localStorage.getItem(KEY), 10);

      // Reset if no target, expired, or duration was changed in code
      if (!target || Date.now() >= target || storedDuration !== DURATION) {
        target = Date.now() + DURATION;
        localStorage.setItem(KEY, target);
        localStorage.setItem(DURKEY, DURATION);
      }

      function tick() {
        var diff = target - Date.now();
        if (diff <= 0) {
          target = Date.now() + DURATION;
          localStorage.setItem(KEY, target);
          diff = DURATION;
        }
        var h = Math.floor(diff / 3600000);
        var m = Math.floor((diff % 3600000) / 60000);
        var s = Math.floor((diff % 60000) / 1000);

        hEl.innerText = h.toString().padStart(2, '0');
        mEl.innerText = m.toString().padStart(2, '0');
        sEl.innerText = s.toString().padStart(2, '0');
      }

      tick();
      setInterval(tick, 1000);
    }
    // Call the functions (if you are placing this inside the IIFE)
    function initV7All() {
      initV7Logic();
      initV7Timer();
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initV7All);
    } else {
      initV7All();
    }

    /* ═══════════════════════════════════════════════════════════════
     PAGESHOW — bfcache restore
    ═══════════════════════════════════════════════════════════════ */
    window.addEventListener('pageshow', function () {
      ['billingToggle'].forEach(function (id) {
        var tgl = document.getElementById(id);
        if (!tgl) return;
        if (!tgl.checked) {
          tgl.checked = true;
          tgl.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
    });
  })();

  (function () {
    'use strict';
    // Core logic to handle all visual changes when toggle is clicked
    function updateVwoToggleState() {
      var toggle = document.getElementById('billingToggle');
      if (!toggle) return;
      var isYearly = toggle.checked;
      // 1. Handle Promo Banners
      var promoBanners = document.querySelectorAll('.ml-promo-banner');
      promoBanners.forEach(function (banner) {
        if (!isYearly) {
          // Force hide when monthly, overriding VWO's CSS changes
          banner.style.setProperty('display', 'none', 'important');
        } else {
          // Clear the inline style so standard CSS takes over when yearly
          banner.style.setProperty('display', 'none', '');
        }
      });
      // 2. Handle Subheading Padding
      var subheadings = document.querySelectorAll('.subheading-text');
      subheadings.forEach(function (sh) {
        if (!isYearly) {
          // Add small padding below when monthly
          sh.style.setProperty('padding-bottom', '12px', 'important');
        } else {
          // Clear the inline padding when yearly
          sh.style.removeProperty('padding-bottom');
        }
      });
      // 3. Handle Specific Plan Option Backgrounds and Borders
      var specificPlans = document.querySelectorAll(
        '.plan_option_qdJDyp, .plan_option_3Qhtg3, .plan_option_jTaNN8 , .plan_option_mc3QWJ, .plan_option_FhN7k6, .plan_option_69yRPd, .plan_option_QEQK3V, .plan_option_iTMbtj, .plan_option_cc7yCq, .plan_option_NWPqV6, .plan_option_iDiEdH, .plan_option_HYC4qn, .plan_option_mCGwUQ, .plan_option_mc3QWJ, .plan_option_v7_CXg3wX'
      );
      specificPlans.forEach(function (plan) {
        // Save the original inline styles before we change them
        if (!plan.hasAttribute('data-original-bg')) {
          plan.setAttribute('data-original-bg', plan.style.backgroundColor || '');
          plan.setAttribute('data-original-border', plan.style.borderColor || '');
        }
        if (!isYearly) {
          // Force transparent background and default border for monthly
          plan.style.setProperty('background-color', 'transparent', 'important');
          plan.style.setProperty('border-color', '#B3C3D3', 'important');
        } else {
          // Restore the original colors from Shopify for yearly
          plan.style.backgroundColor = plan.getAttribute('data-original-bg');
          plan.style.borderColor = plan.getAttribute('data-original-border');
        }
      });
    }
    // Initialization function
    function initVwoLogic() {
      var toggle = document.getElementById('billingToggle');
      // Safety check: VWO sometimes runs before the element is fully rendered
      if (toggle) {
        // 1. Run immediately to set the initial state on page load
        updateVwoToggleState();
        // 2. Attach the listener for when the user clicks the toggle
        toggle.addEventListener('change', updateVwoToggleState);
      } else {
        // Try again in 200ms if the toggle isn't on the page yet
        setTimeout(initVwoLogic, 200);
      }
    }
    // Start the script safely
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initVwoLogic);
    } else {
      initVwoLogic();
    }
  })();

  // URL Injection Builder
  function appendAttributionToPlanUrl(baseUrl) {
    const storedData = localStorage.getItem('inne_first_touch_attr');

    // If no data exists, return the URL exactly as is
    if (!storedData) return baseUrl;

    try {
      const attr = JSON.parse(storedData);
      let attrString = '';

      // Build the encoded attributes string
      for (const [key, value] of Object.entries(attr)) {
        if (value) {
          // Encode both the key and value to prevent breaking the URL structure,
          // and use %26 as the parameter separator for the nested /cart/add
          attrString += `%26attributes[${encodeURIComponent(key)}]=${encodeURIComponent(value)}`;
        }
      }

      // The safest injection point is immediately before the final checkout redirect
      const checkoutRedirectStr = '%26return_to=/checkout';

      if (baseUrl.includes(checkoutRedirectStr)) {
        // Inject attributes before redirecting to checkout
        return baseUrl.replace(checkoutRedirectStr, attrString + checkoutRedirectStr);
      } else {
        // Fallback in case the URL structure changes slightly
        return baseUrl + attrString;
      }
    } catch (error) {
      console.error('Attribution parsing failed', error);
      return baseUrl; // Fail gracefully
    }
  }

  // Example Implementation: Intercepting the Buy Now button
  document.addEventListener('DOMContentLoaded', () => {
    const buyNowBtn = document.querySelector('#your-buy-now-button-id');

    if (buyNowBtn) {
      buyNowBtn.addEventListener('click', function (e) {
        e.preventDefault();

        // 1. Get the target URL from whatever plan is currently selected
        // (Adjust this selector based on how you store the active plan's URL)
        const selectedPlanUrl = document.querySelector('.plan-radio:checked').value;

        // 2. Append the attribution data
        const finalUrl = appendAttributionToPlanUrl(selectedPlanUrl);

        // 3. Execute the redirect
        window.location.href = finalUrl;
      });
    }
  });

  /* ═══════════════════════════════════════════════════════════════
   SELLING PLAN FRESHNESS GUARD
   Selling plan IDs rotate on Shopify/Recharge sync (per Recharge's
   own docs). This checks the embedded ID against live product data
   right before checkout navigation, and repairs it if stale.
═══════════════════════════════════════════════════════════════ */
var SELLING_PLAN_GUARD = (function () {
  var PRODUCT_CONFIG = {
    upfront: {
      6:  { handle: 'PASTE-HANDLE-HERE', sellingPlanId: '6148522250' },
      12: { handle: '12-month-subscription-upfront', sellingPlanId: '6148587786' },
      24: { handle: '24-month-subscription-upfront', sellingPlanId: '6148620554' }
    },
    monthly: {
      6:  { handle: '6-monats-abo-inne-progesterone-strips-monthly',  sellingPlanId: '5583733002' },
      12: { handle: '12-monats-abo-inne-progesterone-strips-monthly', sellingPlanId: '5585600778' },
      24: { handle: '24-monats-abo-inne-progesterone-strips-monthly', sellingPlanId: '5585633546' }
    }
  };

  var CACHE_TTL = 5 * 60 * 1000;
  var cache = {};

  async function getLivePlanId(handle) {
    var entry = cache[handle];
    if (entry && (Date.now() - entry.time < CACHE_TTL)) return entry.id;
    try {
      var res = await fetch('/products/' + handle + '.js');
      var product = await res.json();
      var groups = product.selling_plan_groups || [];
      var id = null;
      for (var i = 0; i < groups.length && !id; i++) {
        var plans = groups[i].selling_plans || [];
        if (plans.length) id = String(plans[0].id); // each product has exactly one plan, confirmed
      }
      cache[handle] = { id: id, time: Date.now() };
      return id;
    } catch (e) {
      console.error('[SellingPlanGuard] Fetch failed for ' + handle, e);
      return entry ? entry.id : null;
    }
  }

  function extractEmbeddedPlanId(url) {
    var decoded = decodeURIComponent(url || '');
    var m = decoded.match(/selling_plan\]=(\d+)/) || decoded.match(/selling_plan=(\d+)/);
    return m ? m[1] : null;
  }

  function correctPlanIdInUrl(url, oldId, newId) {
    if (!oldId || !newId || oldId === newId) return url;
    var patterns = [
      new RegExp('(selling_plan%5D%3D)' + oldId + '(?!\\d)', 'g'),
      new RegExp('(selling_plan\\]=)' + oldId + '(?!\\d)', 'g'),
      new RegExp('(selling_plan=)' + oldId + '(?!\\d)', 'g')
    ];
    var out = url;
    patterns.forEach(function (re) { out = out.replace(re, '$1' + newId); });
    return out;
  }

  async function resolve(staticUrl, months, isUpfront) {
    if (!staticUrl || staticUrl === '#') return staticUrl;
    var config = isUpfront ? PRODUCT_CONFIG.upfront[months] : PRODUCT_CONFIG.monthly[months];
    if (!config) {
      console.warn('[SellingPlanGuard] No config for months=' + months + ' upfront=' + isUpfront);
      return staticUrl;
    }

    try {
      var liveId = await getLivePlanId(config.handle);
      var embeddedId = extractEmbeddedPlanId(staticUrl);

      if (!liveId) {
        console.warn('[SellingPlanGuard] Could not resolve live plan for ' + config.handle);
        return staticUrl;
      }
      if (embeddedId && embeddedId !== liveId) {
        console.warn('[SellingPlanGuard] Stale selling_plan corrected', {
          handle: config.handle, embeddedId: embeddedId, liveId: liveId
        });
        return correctPlanIdInUrl(staticUrl, embeddedId, liveId);
      }
      return staticUrl;
    } catch (e) {
      console.error('[SellingPlanGuard] Validation failed, using static URL', e);
      return staticUrl;
    }
  }

  return { resolve: resolve };
})();
